import React, { ReactNode } from "react";
import styles from "./Skeleton.module.scss";

/**
 * Placeholder for one line of text. It holds a non-breaking space in the
 * surrounding font, so it is exactly one text line tall: wrap it in the same
 * element the loaded text uses and the row keeps its loaded height.
 */
export const SkeletonText = ({ width }: { width: string }) => (
  <span className={styles.text} style={{ width }} aria-hidden="true">
    {" "}
  </span>
);

/** Placeholder that fills a fixed-size parent, such as a progress bar. */
export const SkeletonFill = () => (
  <span className={styles.fill} aria-hidden="true" />
);

/** Tells screen readers what is loading while the placeholders stay hidden. */
export const SkeletonStatus = ({ children }: { children: ReactNode }) => (
  <span className={styles.srOnly} role="status">
    {children}
  </span>
);
